<template>
  <div class="flex flex-col md:flex-row md:justify-between">
    <div class="w-64 flex-shrink-0">
      <span class="text-grayDark font-medium" for="press_kit_bio">About</span>
    </div>
    <div class="md:ml-8 mt-1 md:mt-0 flex-1 flex items-center justify-between">
      <div v-if="! edit" class="w-full flex items-center justify-between">
        <p class="text-blue-800 font-light text-md">{{ modelPressKitBio }}</p>
        <Edit @edit="edit = true"/>
      </div>
      <div v-else class="w-full">
        <ValidationObserver ref="pressKitBioForm" v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(update)" method="post">
            <div>
              <ValidationProvider mode="lazy" rules="required" vid="press_kit_bio" name="Bio" v-slot="{ errors }">
                <div>
                  <div class="">
                    <label for="press_kit_bio" class="sr-only">About</label>
                    <textarea-autosize class="shadow-sm guestio-form-textarea text-sm leading-6 transition-all duration-300" name="press_kit_bio" id="press_kit_bio" v-model="form.press_kit_bio" :min-height="200" />
                  </div>
                  <p class="text-red-500 text-sm mt-1 font-light" v-if="errors.length">{{ errors[0] }}</p>
                </div>
              </ValidationProvider>
            </div>
            <div class="mt-4 flex items-center justify-end">
              <SaveOrCancel @cancel="edit = false" :working="working"/>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
  import Edit from "@/components/shared/Edit";
  import SaveOrCancel from "@/components/shared/SaveOrCancel";

  export default {
    components: {Edit, SaveOrCancel},

    props: {
      model: Object,
      entity: String,
    },

    data() {
      return {
        working: false,
        edit: false,
        form: {
          press_kit_bio: ''
        }
      }
    },

    computed: {
      updateAction() {
        return this.entity == 'guest' ? 'guest/updateGuest' : 'shows/updateShow'
      },

      payload() {
        if (this.entity == 'guest') {
          return {
            id: this.model.id,
            bio: this.form.press_kit_bio,
          }
        }

        return {
          id: this.model.id,
          description: this.form.press_kit_bio,
        }
      },

      modelPressKitBio() {
        return this.entity == 'guest' ? this.model.bio : this.model.description
      }
    },

    watch: {
      model(){
        if (this.model) {
          this.form.press_kit_bio = this.modelPressKitBio
        }
      },

      edit(edit) {
        if (edit) return

        this.form.press_kit_bio = this.modelPressKitBio
      }
    },

    methods: {
      update() {
        this.working = true

        this.$store.dispatch(this.updateAction, this.payload)
          .then(() => {
            this.working = false
            this.edit = false
          })
          .catch(error => {
            this.working = false
            if (error.response) {
              this.$refs.pressKitBioForm.setErrors(error.response.data.errors)
            }
          })
      }
    },

    mounted() {
      this.form.press_kit_bio = this.modelPressKitBio
    }
  }
</script>